/**
 * Curated, consented newsletter capture sources.
 *
 * These are source-qualified, high-intent AI news analyses where readers have
 * a clear reason to request future editorial updates. The server uses this
 * allowlist too, so a public request cannot invent an attribution source.
 */
export const NEWSLETTER_SUBSCRIPTION_SOURCES = [
  {
    slug: "gemini-4-argon-frontier-model-cybersecurity-governance-2026",
    title: "Gemini 4 Argon: Frontier Model Rollout",
    topic: "Frontier models and AI governance",
  },
  {
    slug: "america-gov-phase-1-launch-gemini-and-phase-2",
    title: "America.gov Phase 1 and AI Public Services",
    topic: "AI search and public-sector delivery",
  },
  {
    slug: "instinct-personal-agent-trust-alignment-2026",
    title: "Instinct Personal-Agent Trust and Alignment",
    topic: "Personal agents and delegated authority",
  },
  {
    slug: "cue-by-manus-personal-agent-team-governance-2026",
    title: "Cue by Manus and Agent-Team Governance",
    topic: "Agent identity and controlled delegation",
  },
  {
    slug: "zero-click-commerce-google-ai-mode-checkout-2026",
    title: "Zero-Click Commerce and Google AI Mode",
    topic: "AI search and commerce",
  },
  {
    slug: "ai-agent-landing-page-conversion-layer-2026",
    title: "AI Agents and the Landing-Page Conversion Layer",
    topic: "Agentic conversion and growth",
  },
  {
    slug: "human-in-the-loop-wrong-way-to-govern-ai-agents-2026",
    title: "Human-in-the-Loop Governance for AI Agents",
    topic: "AI governance and controls",
  },
  {
    slug: "buyer-agent-merchant-agent-ecommerce-2026",
    title: "Buyer and Merchant AI Agents",
    topic: "Agentic commerce",
  },
  {
    slug: "openai-gpt-6-1-astra-safety-governance-2026",
    title: "OpenAI GPT-6.1 Astra Safety Governance",
    topic: "Frontier-model safety and oversight",
  },
  {
    slug: "openai-70bn-revenue-run-rate-ipo-economics-2026",
    title: "OpenAI Revenue Run-Rate and AI Economics",
    topic: "Frontier AI economics",
  },
] as const;

export type NewsletterSubscriptionSource = (typeof NEWSLETTER_SUBSCRIPTION_SOURCES)[number];
export type NewsletterSubscriptionSourceSlug = NewsletterSubscriptionSource["slug"];

export function isNewsletterSubscriptionSource(slug: string): slug is NewsletterSubscriptionSourceSlug {
  return NEWSLETTER_SUBSCRIPTION_SOURCES.some((source) => source.slug === slug);
}

export function getNewsletterSubscriptionSource(slug: string): NewsletterSubscriptionSource | undefined {
  return NEWSLETTER_SUBSCRIPTION_SOURCES.find((source) => source.slug === slug);
}
